export const DOCS_BASE_URL = 'https://qualz.ai/docs';

export const DOCS_LINKS = {
  surveyDesign: `${DOCS_BASE_URL}/survey/design-surveys`,
  surveyBuildWithAi: `${DOCS_BASE_URL}/survey/build-surveys-with-ai`,
  surveyConfigureShare: `${DOCS_BASE_URL}/survey/configure-and-share-survey`,
  surveyAnalyze: `${DOCS_BASE_URL}/survey/how-to-analyze-survey`,
  surveyAnalyzeExisting: `${DOCS_BASE_URL}/survey/aanalyze-your-existing-survey-data`,
  surveyReports: `${DOCS_BASE_URL}/survey/create-and-survey-reports`,
  interviewCreate: `${DOCS_BASE_URL}/ai-moderated-interview/ai-moderated-interview`,
  interviewQuestionsWithAi: `${DOCS_BASE_URL}/ai-moderated-interview/interview-questions-with-ai`,
  interviewConfigure: `${DOCS_BASE_URL}/ai-moderated-interview/configure-interview-study`,
  interviewShare: `${DOCS_BASE_URL}/ai-moderated-interview/how-to-share-an-interview-study-with-participants`,
  interviewModes: `${DOCS_BASE_URL}/ai-moderated-interview/standard-ai-moderated-interview-and-advanced-ai-moderated-interview`,
  analysisOverview: `${DOCS_BASE_URL}/ai-analysis/what-is-multi-lens-analysis`,
  analysisRun: `${DOCS_BASE_URL}/ai-analysis/analyze-interview-data`,
  aiParticipantsGenerate: `${DOCS_BASE_URL}/ai-participants/generating-ai-participants`,
  aiParticipantsSend: `${DOCS_BASE_URL}/ai-participants/study-to-ai-participants`,
  aiParticipantsFilter: `${DOCS_BASE_URL}/ai-participants/filter-ai-participants`,
  aiParticipantsAnalyzeSurvey: `${DOCS_BASE_URL}/ai-participants/how-to-analyze-your-survey-with-ai-participants`,
  workspaceOverview: `${DOCS_BASE_URL}/workspace/how-to-create-and-switch-workspaces-in-qualz-ai-complete-guide`,
  workspaceUpgrade: `${DOCS_BASE_URL}/workspace/how-to-upgrade-workspace-plans-in-qualz-ai`,
};
